import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files for English
import enApp from './locales/en/namespaces/app.json';
import enAuth from './locales/en/namespaces/auth.json';
import enCalendar from './locales/en/namespaces/calendar.json';
import enCommon from './locales/en/namespaces/common.json';
import enDashboard from './locales/en/namespaces/dashboard.json';
import enDepartments from './locales/en/namespaces/departments.json';
import enDeputyMinistries from './locales/en/namespaces/deputy-ministries.json';
import enDirectorates from './locales/en/namespaces/directorates.json';
import enDocuments from './locales/en/namespaces/documents.json';
import enMinistries from './locales/en/namespaces/ministries.json';
import enNavigation from './locales/en/namespaces/navigation.json';
import enProfile from './locales/en/namespaces/profile.json';
import enProvinces from './locales/en/namespaces/provinces.json';
import enRoles from './locales/en/namespaces/roles.json';
import enSettings from './locales/en/namespaces/settings.json';
import enTasks from './locales/en/namespaces/tasks.json';
import enUsers from './locales/en/namespaces/users.json';
import enValidation from './locales/en/namespaces/validation.json';
import enWorkflows from './locales/en/namespaces/workflows.json';
import enReports from './locales/en/namespaces/reports.json';
import enNotifications from './locales/en/namespaces/notifications.json';
import enSuperadmin from './locales/en/namespaces/superadmin.json';
import enLimitedadmin from './locales/en/namespaces/limitedadmin.json';

// Import translation files for Dari
import dariApp from './locales/dari/namespaces/app.json';
import dariAssignedByMe from './locales/dari/namespaces/assigned_by_me.json';
import dariAuth from './locales/dari/namespaces/auth.json';
import dariCalendar from './locales/dari/namespaces/calendar.json';
import dariCommon from './locales/dari/namespaces/common.json';
import dariDashboard from './locales/dari/namespaces/dashboard.json';
import dariDepartments from './locales/dari/namespaces/departments.json';
import dariDeputyMinistries from './locales/dari/namespaces/deputy-ministries.json';
import dariDirectorates from './locales/dari/namespaces/directorates.json';
import dariDocuments from './locales/dari/namespaces/documents.json';
import dariMinistries from './locales/dari/namespaces/ministries.json';
import dariMyAssignments from './locales/dari/namespaces/my_assignments.json';
import dariNavigation from './locales/dari/namespaces/navigation.json';
import dariProfile from './locales/dari/namespaces/profile.json';
import dariProvinces from './locales/dari/namespaces/provinces.json';
import dariRoles from './locales/dari/namespaces/roles.json';
import dariSettings from './locales/dari/namespaces/settings.json';
import dariTasks from './locales/dari/namespaces/tasks.json';
import dariUsers from './locales/dari/namespaces/users.json';
import dariValidation from './locales/dari/namespaces/validation.json';
import dariWorkflows from './locales/dari/namespaces/workflows.json';
import dariReports from './locales/dari/namespaces/reports.json';
import dariNotifications from './locales/dari/namespaces/notifications.json';
import dariSuperadmin from './locales/dari/namespaces/superadmin.json';
import dariLimitedadmin from './locales/dari/namespaces/limitedadmin.json';

// Import translation files for Pashto
import pashtoApp from './locales/pashto/namespaces/app.json';
import pashtoAssignedByMe from './locales/pashto/namespaces/assigned_by_me.json';
import pashtoAuth from './locales/pashto/namespaces/auth.json';
import pashtoCalendar from './locales/pashto/namespaces/calendar.json';
import pashtoCommon from './locales/pashto/namespaces/common.json';
import pashtoDashboard from './locales/pashto/namespaces/dashboard.json';
import pashtoDepartments from './locales/pashto/namespaces/departments.json';
import pashtoDeputyMinistries from './locales/pashto/namespaces/deputy-ministries.json';
import pashtoDirectorates from './locales/pashto/namespaces/directorates.json';
import pashtoDocuments from './locales/pashto/namespaces/documents.json';
import pashtoMinistries from './locales/pashto/namespaces/ministries.json';
import pashtoMyAssignments from './locales/pashto/namespaces/my_assignments.json';
import pashtoNavigation from './locales/pashto/namespaces/navigation.json';
import pashtoProfile from './locales/pashto/namespaces/profile.json';
import pashtoProvinces from './locales/pashto/namespaces/provinces.json';
import pashtoRoles from './locales/pashto/namespaces/roles.json';
import pashtoSettings from './locales/pashto/namespaces/settings.json';
import pashtoTasks from './locales/pashto/namespaces/tasks.json';
import pashtoUsers from './locales/pashto/namespaces/users.json';
import pashtoValidation from './locales/pashto/namespaces/validation.json';
import pashtoWorkflows from './locales/pashto/namespaces/workflows.json';
import pashtoReports from './locales/pashto/namespaces/reports.json';
import pashtoNotifications from './locales/pashto/namespaces/notifications.json';
import pashtoSuperadmin from './locales/pashto/namespaces/superadmin.json';
import pashtoLimitedadmin from './locales/pashto/namespaces/limitedadmin.json';

// Configure resources with namespaces
const resources = {
  en: {
    app: enApp,
    auth: enAuth,
    calendar: enCalendar,
    common: enCommon,
    dashboard: enDashboard,
    departments: enDepartments,
    deputyMinistries: enDeputyMinistries,
    directorates: enDirectorates,
    documents: enDocuments,
    ministries: enMinistries,
    navigation: enNavigation,
    profile: enProfile,
    provinces: enProvinces,
    roles: enRoles,
    settings: enSettings,
    tasks: enTasks,
    users: enUsers,
    validation: enValidation,
    workflows: enWorkflows,
    reports: enReports,
    notifications: enNotifications,
    superadmin: enSuperadmin,
    limitedadmin: enLimitedadmin,
    assigned_by_me: enTasks, // Fallback to tasks for English
    my_assignments: enTasks  // Fallback to tasks for English
  },
  dari: {
    app: dariApp,
    assigned_by_me: dariAssignedByMe,
    auth: dariAuth,
    calendar: dariCalendar,
    common: dariCommon,
    dashboard: dariDashboard,
    departments: dariDepartments,
    deputyMinistries: dariDeputyMinistries,
    directorates: dariDirectorates,
    documents: dariDocuments,
    ministries: dariMinistries,
    my_assignments: dariMyAssignments,
    navigation: dariNavigation,
    profile: dariProfile,
    provinces: dariProvinces,
    roles: dariRoles,
    settings: dariSettings,
    tasks: dariTasks,
    users: dariUsers,
    validation: dariValidation,
    workflows: dariWorkflows,
    reports: dariReports,
    notifications: dariNotifications,
    superadmin: dariSuperadmin,
    limitedadmin: dariLimitedadmin
  },
  ps: {
    app: pashtoApp,
    assigned_by_me: pashtoAssignedByMe,
    auth: pashtoAuth,
    calendar: pashtoCalendar,
    common: pashtoCommon,
    dashboard: pashtoDashboard,
    departments: pashtoDepartments,
    deputyMinistries: pashtoDeputyMinistries,
    directorates: pashtoDirectorates,
    documents: pashtoDocuments,
    ministries: pashtoMinistries,
    my_assignments: pashtoMyAssignments,
    navigation: pashtoNavigation,
    profile: pashtoProfile,
    provinces: pashtoProvinces,
    roles: pashtoRoles,
    settings: pashtoSettings,
    tasks: pashtoTasks,
    users: pashtoUsers,
    validation: pashtoValidation,
    workflows: pashtoWorkflows,
    reports: pashtoReports,
    notifications: pashtoNotifications,
    superadmin: pashtoSuperadmin,
    limitedadmin: pashtoLimitedadmin
  }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'dari', // Default to Dari
    debug: process.env.NODE_ENV === 'development',
    
    // Default namespace is 'common'
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    // RTL support
    react: {
      useSuspense: true,
    },
    
    // Handle RTL based on language
    returnObjects: true,
    
    // Set the initial language explicitly (this can be overridden by user preference)
    lng: localStorage.getItem('i18nextLng') || 'dari',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Handle RTL direction changes when language changes
const handleLanguageChange = (lng) => {
  const html = document.documentElement;
  
  // Set RTL for Dari and Pashto
  if (lng === 'dari' || lng === 'ps') {
    html.setAttribute('dir', 'rtl');
    html.setAttribute('lang', lng);
    
    // Add RTL styles
    document.body.style.direction = "rtl";
    document.body.style.textAlign = "right";
  } else {
    html.setAttribute('dir', 'ltr');
    html.setAttribute('lang', lng);
    
    // Reset to LTR styles
    document.body.style.direction = "ltr";
    document.body.style.textAlign = "left";
  }
};

// Set initial direction based on stored language
handleLanguageChange(i18n.language);

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  console.log('i18n language changed to:', lng);
  handleLanguageChange(lng);
});

export default i18n; 